import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d91be5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Loading node information")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Error loading node information")

import { watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { kebabCase } from "lodash";
import { lookupNode } from "@/api/node-lookup";
import TheTableOfContents from "@/components/TheTableOfContents.vue";
import SectionTitle from "./SectionTitle.vue";
import SectionOverview from "./SectionOverview.vue";
import SectionDetails from "./SectionDetails.vue";
import SectionHierarchy from "./SectionHierarchy.vue";
import SectionVisualization from "./SectionVisualization.vue";
import SectionAssociations from "./SectionAssociations.vue";
import SectionBreadcrumbs from "./SectionBreadcrumbs.vue";
import { scrollToHash } from "@/router";
import { useQuery } from "@/util/composables";
import { appDescription, appTitle } from "@/global/meta";
import { addEntry } from "@/global/history";

/** route info */

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNode',
  setup(__props) {

const route = useRoute();

/** get new node data */
const {
  query: getNode,
  data: node,
  isLoading,
  isError,
} = useQuery(
  async function () {
    /** get node from route params */
    const { id = "", category = "" } = route.params;

    /** get node information */
    return await lookupNode(id as string, category as string);
  },

  /** default value */
  null,

  /** on success, after data loaded */
  async (results) => {
    /** scroll to hash */
    await nextTick();
    scrollToHash();

    /**
     * set page description from node meta data. no need to include category and
     * id, as those should already be in the document title. see
     * https://metatags.io/
     */
    const { name = "", description = "" } = results || {};
    appDescription.value = [name, description]
      .filter((part) => part)
      .join(" | ");
  }
);

/** when path (not hash or query) changed, get new node data */
watch(() => route.path, getNode);

/** update document title */
watch(
  [() => route.fullPath, () => node.value?.name],
  () => {
    appTitle.value = [
      node.value?.name,
      // `${route.params.id} (${route.params.category})`,
      route.query.associations ? `${route.query.associations} assoc.` : "",
    ];
  },
  /** https://github.com/vuejs/vue-router/issues/3393 */
  { immediate: true, flush: "post" }
);

/** update node history on node visit */
watch([() => node.value?.name], () => addEntry(node.value?.name), {
  immediate: true,
});

/** get new node data on load */
onMounted(getNode);

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _component_AppStatus = _resolveComponent("AppStatus")!

  return (_unref(isLoading) || _unref(isError))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_AppSection, {
          design: "fill",
          class: "section"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AppHeading, {
              class: "heading",
              icon: `category-${_unref(kebabCase)(String(_ctx.$route.params.category))}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$route.params.id), 1)
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppSection, null, {
          default: _withCtx(() => [
            (_unref(isLoading))
              ? (_openBlock(), _createBlock(_component_AppStatus, {
                  key: 0,
                  code: "loading"
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isError))
              ? (_openBlock(), _createBlock(_component_AppStatus, {
                  key: 1,
                  code: "error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 64))
    : (_unref(node))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(SectionTitle, { node: _unref(node) }, null, 8, ["node"]),
          _createVNode(SectionOverview, { node: _unref(node) }, null, 8, ["node"]),
          _createVNode(SectionDetails, { node: _unref(node) }, null, 8, ["node"]),
          _createVNode(SectionHierarchy, { node: _unref(node) }, null, 8, ["node"]),
          _createVNode(SectionVisualization, { node: _unref(node) }, null, 8, ["node"]),
          _createVNode(SectionAssociations, { node: _unref(node) }, null, 8, ["node"]),
          _createVNode(SectionBreadcrumbs, { node: _unref(node) }, null, 8, ["node"]),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(TheTableOfContents)
          ]))
        ], 64))
      : _createCommentVNode("", true)
}
}

})